import { createAction } from 'redux-actions';
import { updateOperatorMutationGQL } from './graphql';
import { operatorCreateApi } from './graphql/operatorCreateApi';

export const types = {
  OPEN_OPERATOR_EDIT_MODAL: 'admin/operatorList/OPEN_OPERATOR_EDIT_MODAL',
  CLOSE_OPERATOR_EDIT_MODAL: 'admin/operatorList/CLOSE_OPERATOR_EDIT_MODAL',

  OPEN_OPERATOR_MERGE_MODAL: 'admin/operatorList/OPEN_OPERATOR_MERGE_MODAL',
  CLOSE_OPERATOR_MERGE_MODAL: 'admin/operatorList/CLOSE_OPERATOR_MERGE_MODAL',

  OPEN_OPERATOR_ADD_MODAL: 'admin/operatorList/OPEN_OPERATOR_ADD_MODAL',
  CLOSE_OPERATOR_ADD_MODAL: 'admin/operatorList/CLOSE_OPERATOR_ADD_MODAL',
};

export const openOperatorEditModal = createAction(types.OPEN_OPERATOR_EDIT_MODAL);
export const closeOperatorEditModal = createAction(types.CLOSE_OPERATOR_EDIT_MODAL);

export const openOperatorMergeModal = createAction(types.OPEN_OPERATOR_MERGE_MODAL);
export const closeOperatorMergeModal = createAction(types.CLOSE_OPERATOR_MERGE_MODAL);

export const openOperatorAddModal = createAction(types.OPEN_OPERATOR_ADD_MODAL);
export const closeOperatorAddModal = createAction(types.CLOSE_OPERATOR_ADD_MODAL);

export const dispatchUpdateOperator = (operator) => {
  return async (dispatch, getState, { client }) => {
    await updateOperatorMutationGQL(client, operator);
    dispatch(closeOperatorEditModal());
  };
};

export const createOperator = (operatorName) => {
  return async (dispatch, getState, { client }) => {
    await operatorCreateApi(client, operatorName);
  };
};
